import {
	BriefcaseIcon,
	HomeIcon,
	MailIcon,
	PackageIcon,
	PencilIcon,
	SettingsIcon,
	UserIcon,
	type LucideIcon,
} from 'lucide-react'
import { Dock, DockIcon } from '#app/components/magicui/dock.tsx'
import { buttonVariants } from '#app/components/ui/button.tsx'
import { cn } from '#app/utils/misc.tsx'

// Single-page section nav (gxuri-style). Each item scrolls to a section id.
// Social links live in the Contact section, not here.
const sections: { href: string; icon: LucideIcon; label: string }[] = [
	{ href: '#hero', icon: HomeIcon, label: 'Home' },
	{ href: '#about', icon: UserIcon, label: 'About' },
	{ href: '#work', icon: BriefcaseIcon, label: 'Work' },
	{ href: '#projects', icon: PackageIcon, label: 'Projects' },
	{ href: '#writing', icon: PencilIcon, label: 'Writing' },
	{ href: '#contact', icon: MailIcon, label: 'Contact' },
	{ href: '#settings', icon: SettingsIcon, label: 'Settings' },
]

const iconLinkClass = cn(
	buttonVariants({ variant: 'ghost', size: 'icon' }),
	'size-12',
)

export function Navbar() {
	return (
		// `print:hidden` — the dock is fixed-position, so it rendered on top of the
		// generated résumé PDF (`npm run resume:pdf`). Navigation chrome has no place
		// in a printed page.
		<div className="pointer-events-none fixed inset-x-0 bottom-0 z-30 flex justify-center pb-5 print:hidden">
			{/* mt-0 overrides the magicui dockVariants default mt-8, which otherwise
			    pushes the dock down off the bottom of the viewport. */}
			<Dock className="bg-background/90 pointer-events-auto mt-0 shadow-lg">
				{sections.map((item) => (
					<DockIcon key={item.href}>
						<a
							href={item.href}
							aria-label={item.label}
							className={iconLinkClass}
						>
							<item.icon className="size-4" />
						</a>
					</DockIcon>
				))}
			</Dock>
		</div>
	)
}

export default Navbar
